import { MSConstant } from '@/commons/wildcards'
export default {

  updateContext (state, payload) {
    state.TokenExpired = new Date().addSeconds(payload.TokenTimeout)
    state.Token = payload.Token
    state.User = payload.User
    state.Context = payload.Context
    state.Permission = payload.Permission || null
  },

  updateUser (state, payload) {
    state.User = payload
  },

  updateAccessToken (state, token) {
    state.Token = token
  },

  updateLogout: function (state) {
    state.Token = null
    state.Context = null
    state.TokenExpired = null
    state.User = null
    state.Permission = null

    localStorage.removeItem(MSConstant.Storage.Local.Context)
    localStorage.removeItem(MSConstant.Storage.Local.Token)
  },

  updateLoading (state, payload) {
    state.Loading = payload
  },

  updatePermission (state, payload) {
    state.Permission = payload
  },

  updateLeftMenuCollapse (state, payload) {
    state.LeftMenuCollapse = payload
  },

  /**
   * Cập nhật thông tin năm học
   * @param {*} state
   * @param {*} payload
   */
  updateSchoolYear (state, payload) {
    state.Context.CurrentSchoolYear = payload
  },

  /**
   * Cập nhật thông tin cấp học
   * @param {*} state
   * @param {*} payload
   */
  updateSchoolLevel (state, payload) {
    state.Context.CurrentSchoolLevel = payload
  },
}
